<template lang='pug'>
  i.svg-icon.svg-icon-facebook
    svg(
      :width='`${size}px`'
      :height='`${size}px`'
      viewBox='0 0 100 100'
    )
      path(fill='#4062A7' d='M85.372,10.073H14.625c-2.422,0.001-4.386,1.966-4.386,4.389v70.747c0.001,2.421,1.966,4.387,4.389,4.385 h70.744c2.423,0.002,4.388-1.964,4.389-4.387v-0.002V14.458C89.76,12.036,87.795,10.072,85.372,10.073z')
      path(fill='#FFFFFF' d='M65.143,89.594V58.842h10.368l1.553-12.037H65.143v-7.666c0-3.477,0.966-5.846,5.952-5.846h6.319V22.556 c-1.101-0.146-4.872-0.473-9.261-0.473c-9.163,0-15.435,5.591-15.435,15.864v8.858H42.39v12.037h10.329v30.752H65.143z')

</template>

<script>
export default {

  props: {
    size: {
      type: Number,
      default: 20,
    },
    color: {
      type: String,
      default: '#333',
    },
  },
};

</script>
